import styled from 'styled-components';
import { bouTitleFontStyle } from '../../../../../../generic/content/texts/bou-title/title-style';
import { BouColor } from '../../../../../../generic/global/bou-colors';

export interface Props {}

export const Text = styled.text`
  ${bouTitleFontStyle};
  fill: ${BouColor.IMPACT_COLUMN_TITLE_GRAY};
  font-weight: bold;
  text-transform: uppercase;
`;
